(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/toplists/receiver-toplists-most-popular-points-list.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/toplists/receiver-toplists-most-popular-points-list.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.views.ReceiverToplistsMostPopularPointsList = Marionette.CollectionView.extend({
    childView: svs.grassroots.views.ReceiverGenericItem,
    childViewOptions: function(model) {
      return {
        attributes: {
          'aria-expanded': 'false',
          'aria-controls': `grassroots-most-popular-points-${model.id}`,
          'data-index': model.id
        },
        childIndex: model.id,
        className: `most-popular-receiver accordion-item js-accordion-item-${model.id} js-accordion-item`,
        type: 'topselectionPoints',
        tabName: 'mostPopularPoints',
        path: 'valj',
        tagName: 'li'
      };
    },
    tagName: 'ul',
    className: 'accordion accordion-customer-sport accordion-default js-receiver-accordion-toplist-most-popular-points js-receiver-toplists-most-popular-points js-accordion',
    emptyView: svs.grassroots.views.ReceiverToplistsEmpty,
    viewFilter: function(view) {
      return view.model.attributes.topselectionPoints;
    },
    onAttach: function(view) {
      new svs.ui.Accordion({ el: view.el });
    }
  });
})(Backbone, _, svs);


 })(window);